/**
 * Pure TEA update for the link URL dialog (ProseMirror editor, #249).
 *
 * Shell: `LinkDialog.vue` (prop `open` drives Seed + focus Cmd).
 */
import { assertNever } from "../lib/assertNever";
import type { UpdateFn } from "../lib/tea";

export type LinkDialogModel = {
  readonly draft: string;
};

export const initialLinkDialogModel: LinkDialogModel = { draft: "" };

export type LinkDialogMsg =
  | { readonly type: "Seed"; readonly href: string }
  | { readonly type: "DraftChanged"; readonly draft: string }
  | { readonly type: "Apply" };

export type LinkDialogCmd =
  | { readonly kind: "focusInput" }
  | { readonly kind: "apply"; readonly href: string };

export function updateLinkDialog(
  model: LinkDialogModel,
  msg: LinkDialogMsg,
): readonly [LinkDialogModel, readonly LinkDialogCmd[]] {
  switch (msg.type) {
    case "Seed":
      return [{ draft: msg.href }, [{ kind: "focusInput" }]];
    case "DraftChanged":
      return [{ draft: msg.draft }, []];
    case "Apply":
      return [model, [{ kind: "apply", href: model.draft.trim() }]];
    default:
      return assertNever(msg);
  }
}

export const updateLinkDialogFn: UpdateFn<
  LinkDialogModel,
  LinkDialogMsg,
  LinkDialogCmd
> = updateLinkDialog;
